// Helper function to get value from localStorage or fallback
function getStored(key, defaultValue) {
  return localStorage.getItem(key) || defaultValue;
}

export const state = {
  layoutType: getStored("themeLayoutType", "vertical"),
  layoutWidth: getStored("themeLayoutWidth", "fluid"),
  sidebarSize: getStored("themeSidebarSize", "lg"),
  topbar: getStored("themeTopbar", "light"),
  mode: getStored("themeMode", "light"),
  position: getStored("themePosition", "fixed"),
  sidebarView: getStored("themeSidebarView", "default"),
  sidebarColor: getStored("themeSidebarColor", "dark"),
  sidebarImage: getStored("themeSidebarImage", "none"),
  preloader: getStored("themePreloader", "disable"),
  visibility: getStored("themeVisibility", "show"),
};

export const mutations = {
  // Generic mutation to change any layout property and persist
  SET_LAYOUT_PROPERTY(state, { key, value, persist = true }) {
    if (Object.prototype.hasOwnProperty.call(state, key)) {
      state[key] = value;
      if (persist) localStorage.setItem(`theme${capitalize(key)}`, value);
    }
  },
};

// Helper to capitalize key names for localStorage
function capitalize(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

export const actions = {
  changeLayoutType({ commit }, { layoutType }) {
    commit("SET_LAYOUT_PROPERTY", { key: "layoutType", value: layoutType });
    document.body.removeAttribute("style");
  },

  changeLayoutWidth({ commit }, { layoutWidth }) {
    commit("SET_LAYOUT_PROPERTY", { key: "layoutWidth", value: layoutWidth });
  },

  changeSidebarSize({ commit }, { sidebarSize }) {
    commit("SET_LAYOUT_PROPERTY", { key: "sidebarSize", value: sidebarSize });
  },

  changeTopbar({ commit }, { topbar }) {
    commit("SET_LAYOUT_PROPERTY", { key: "topbar", value: topbar });
  },

  changeMode({ commit }, { mode }) {
    commit("SET_LAYOUT_PROPERTY", { key: "mode", value: mode });
  },

  changePosition({ commit }, { position }) {
    commit("SET_LAYOUT_PROPERTY", { key: "position", value: position });
  },

  changeSidebarView({ commit }, { sidebarView }) {
    commit("SET_LAYOUT_PROPERTY", { key: "sidebarView", value: sidebarView });
  },

  changeSidebarColor({ commit }, { sidebarColor }) {
    commit("SET_LAYOUT_PROPERTY", { key: "sidebarColor", value: sidebarColor });
  },

  changeSidebarImage({ commit }, { sidebarImage }) {
    commit("SET_LAYOUT_PROPERTY", { key: "sidebarImage", value: sidebarImage });
  },

  changePreloader({ commit }, { preloader }) {
    commit("SET_LAYOUT_PROPERTY", { key: "preloader", value: preloader });
  },

  changeVisibility({ commit }, { visibility }) {
    commit("SET_LAYOUT_PROPERTY", { key: "visibility", value: visibility });
  },
};
